module.exports = "../dist/frontend/icons/ui/close.svg?5277828a7eb0b4be2a38f765d1ad4649";